import { useEffect, useState } from "react";
import { TextField, Toast, Form, AlphaCard, Image, Badge, Box, Button, Divider, HorizontalGrid, HorizontalStack, Icon, Link, Page, Select, Text, VerticalStack, Spinner, ButtonGroup, ResourceList, ResourceItem, Tabs, Modal, useBreakpoints } from "@shopify/polaris";
import {
  auth, doPasswordReset, signInWithGoogle, createEmailSignIn, checkIfEmailLink, emailPasswordSignIn,
  savePaypalMerchantID, getPaypalOnboardingLink, getDealData, checkPaypalStatus, getCreator, getPosts, getContent, getPublicStore,
  saveAddress, checkEmail, setupFirstLogin
} from "../firebase";
import { ClockMajor, ThumbsUpMajor, CashDollarMajor, ImageMajor, TeamMajor, ProfileMajor, DuplicateMinor, CircleTickMajor, CancelMajor, EnvelopeMajor, UploadMajor, TickMinor, LocationMajor, OrdersMajor, BillingStatementDollarMajor, BehaviorMajor, LinkMinor } from "@shopify/polaris-icons";

import { copyToClipboard, getCountry } from "../utils";

import { getEmbedByVimeoID } from '../vimeo'
import { useQuery } from "@tanstack/react-query";
import { NewTopBar } from "../components/NewTopBar";
import Earnings from "./earnings";
import DealModal from "../components/deal-modal";
import AffiliateTable from "../components/AffiliateTable";
import PaymentsTable from "../components/PaymentsTable";

import loadingGif from '../assets/pup-loading.gif'
import googleLogo from '../assets/google-logo.png'
import { AddressElement } from "@stripe/react-stripe-js";

const MAPS_KEY = 'AIzaSyACFv1SiRtvQ6IsAwoRJZeiT8c_UZp9pFQ'

export default function HomePage() {

  const [selectedDeal, setSelectedDeal] = useState(0)
  const [merchantIDSaved, setMerchantIDSaved] = useState(false)
  const [selectedPaymentTab, setSelectedPaymentTab] = useState(0)
  const [infoModalMarkup, setInfoModalMarkup] = useState(null)
  const [selectedProfile, setSelectedProfile] = useState(0);

  const [checkEmailLoading, setCheckEmailLoading] = useState(false)

  const [localAddress, setLocalAddress] = useState(null)
  const [saveAddressLoading, setSaveAddressLoading] = useState(false)

  const [removePaypalLoading, setRemovePaypalLoading] = useState(false)
  const [onboardingLoading, setOnboardingLoading] = useState(false)

  const [authUser, setAuthUser] = useState(null);
  const [authLoaded, setAuthLoaded] = useState(false);

  const [signInWithEmailPassword, setSignInWithEmailPassword] = useState(null);
  const [passwordResetSent, setPasswordResetSent] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailInviteSent, setEmailInviteSent] = useState(false);
  const [captureEmail, setCaptureEmail] = useState(false);

  const [toasts, setToasts] = useState([]);

  const toastMarkup = toasts.map((toast) => (
    <Toast
      key={toast.msg}
      content={toast.msg}
      error={toast.error}
      onDismiss={() => {
        const toastsCopy = [...toasts];
        toastsCopy.splice(toastsCopy.indexOf(toast), 1);
        setToasts(toastsCopy);
      }} />
  ))

  useEffect(() => {
    // listen for auth state changes
    const unsub = auth.onAuthStateChanged((user) => {
      if (window.location.search.includes('emailLink') && !user) {
        checkIfEmailLink();
      }
      if (user) {
        setAuthUser(user);
      } else {
        setAuthUser(null);
      }
      setAuthLoaded(true);
    });
    return unsub;
  }, []);

  // get custom subdomain from url
  const subdomain = window.location.hostname.split('.')[0]
  console.log('subdomain', subdomain)
  const {
    data: publicStore
  } = useQuery({
    queryKey: ['publicStore', subdomain],
    enabled: subdomain !== 'app',
    queryFn: async () => {
      const publicStore = await getPublicStore(subdomain)
      if (publicStore) {
        // set html title
        document.title = `${publicStore?.name} - Creator Portal`
      } else {
        document.title = 'Creator Portal'
      }
      return publicStore
    }
  })
  console.log('publicStore', publicStore)

  const {
    data: profiles,
    isLoading: profilesLoading,
    error,
    refetch: refetchProfiles
  } = useQuery({
    queryKey: ['creator', authUser?.email],
    enabled: !!authUser,
    queryFn: () => {
      return getCreator()
    },
  });

  console.log('profiles', profiles)

  const profile = profiles?.[selectedProfile]
  // check for QS from paypal onboarding
  useEffect(() => {
    if (profile?.id && !merchantIDSaved) {
      const urlParams = new URLSearchParams(window.location.search);
      const merchantID = urlParams.get('merchantIdInPayPal');

      if (merchantID) {
        checkPaypalStatus({ merchantID }).then((res) => {
          savePaypalMerchantID(profile?.id, res.data).then(() => {
            refetchProfiles()
          })
        })
      } else if (profile?.paypalOnboardingStarted) {
        checkPaypalStatus({ merchantID: profile?.paypalMerchantID, creatorID: profile?.id }).then((response) => {
          const res = response.data
          if (!res) return
          console.log('saving res', res)
          if (res.primary_email_confirmed !== profile?.paypalEmailConfirmed || res.payments_receivable !== profile?.paypalPaymentsReceivable || res.merchant_id !== profile?.paypalMerchantID) {
            savePaypalMerchantID(profile?.id, res).then(() => {
              refetchProfiles()
            })
          }
        })
      }
      setMerchantIDSaved(true)
    }
    if (profile?.address?.address) {
      setLocalAddress(profile?.address)
    }
  }, [selectedProfile])

  console.log('selectedDeal', selectedDeal)
  const selectedDealID = profile?.deals[selectedDeal]?.id
  const {
    data: dealData,
    isLoading,
    error: dealError,
    refetch: refetchDeal,
  } = useQuery({
    queryKey: ['deal', selectedDealID],
    queryFn: async () => {
      if (selectedDealID) {
        return (await getDealData(selectedDealID))?.data
      } else {
        return { data: {} }
      }
    }
  });
  const {
    data: content,
    isLoading: contentLoading,
    error: contentError,
    refetch: refetchContent,
  } = useQuery({
    queryKey: ['content', selectedDealID],
    queryFn: async () => {
      const content = await getContent(selectedDealID)
      // getAllVimeoEmbeds(content)
      return content
    },
  });

  const {
    data: posts
  } = useQuery({
    queryKey: ['posts', selectedDealID],
    queryFn: async () => {
      return getPosts(selectedDealID)
    }
  })


  const loadingMarkup = (
    <Box padding="32">
      <VerticalStack inlineAlign="center" align="center">
        <Image width="400px" src={loadingGif} alt="Loading" />
      </VerticalStack>
    </Box>
  )
  if (!authLoaded) {
    return loadingMarkup
  } else if (!authUser) {
    return (
      <Modal small open={true} titleHidden={true}>
        <Box padding={"10"}>
          <VerticalStack gap="5">
            {
              emailInviteSent ? (
                <>
                  <VerticalStack gap="3">
                    <Text variant="headingLg">Login Link Sent!</Text>
                    <Text>Check your email "{email}", (and spam folder) to sign in</Text>
                    <HorizontalStack gap="3" align="center">
                      <Link removeUnderline onClick={() => setEmailInviteSent(false)}>Back</Link>
                      <Link removeUnderline onClick={createEmailSignIn(email, () => { })}>Send Again</Link>
                    </HorizontalStack>
                  </VerticalStack>
                </>
              ) : captureEmail ? (
                <>
                  <VerticalStack gap="3">
                    <Text variant="headingLg">What is Your Email?</Text>
                    <TextField type="email" value={email} onChange={(value) => setEmail(value)} />
                    <Button onClick={() => createEmailSignIn(email, () => {
                      setEmailInviteSent(true);
                    })}>
                      <Text>
                        Send Sign In Link
                      </Text>
                    </Button>
                    <HorizontalStack gap="3" align="center">
                      <Link removeUnderline onClick={() => setCaptureEmail(false)}>Back</Link>
                    </HorizontalStack>
                  </VerticalStack>
                </>
              ) : (
                <>
                  <VerticalStack gap="3" inlineAlign="center">
                    {
                      publicStore?.logo ? (
                        <Image source={publicStore?.logo} width={'60%'} />
                      ) : null
                    }
                    <Text>Log In To Access Your Creator Portal</Text>
                  </VerticalStack>
                  <Divider />
                  {
                    checkEmailLoading ? (
                      <Spinner />
                    ) : signInWithEmailPassword === 1 ? (
                      <VerticalStack gap="3">
                        <Form onSubmit={async e => {
                          e.preventDefault()
                          try {
                            setCheckEmailLoading(true)
                            const { data: emailStatus } = await checkEmail({ email })
                            console.log('emailStatus', emailStatus)
                            if (emailStatus?.hasAccount) {
                              if (emailStatus?.isGoogleUser) {
                                setSignInWithEmailPassword(6) // login
                              } else {
                                setSignInWithEmailPassword(2) // login
                              }
                            } else if (emailStatus.exists) {
                              setSignInWithEmailPassword(3) // create account
                            } else {
                              setSignInWithEmailPassword(4) // no email
                            }
                          } catch (e) {
                            console.error(e)
                          } finally {
                            setCheckEmailLoading(false)
                          }
                        }}>
                          <VerticalStack gap="3">
                            <TextField
                              label="Email"
                              type="email"
                              value={email}
                              onChange={(value) => setEmail(value)}
                              autoFocus
                            />
                            <Button submit>
                              Next
                            </Button>
                          </VerticalStack>
                        </Form>
                        <VerticalStack gap="3" align="center">
                          <Link removeUnderline onClick={() => setSignInWithEmailPassword(null)}>Back</Link>
                        </VerticalStack>
                      </VerticalStack>
                    ) : signInWithEmailPassword === 6 ? (
                      <VerticalStack gap="3">
                        <VerticalStack inlineAlign="center" gap="3">
                          <Text variant="headingLg">{email}</Text>
                          <Text>You Signed Up With Google</Text>
                        </VerticalStack>
                        <Button onClick={signInWithGoogle}>
                          <HorizontalStack blockAlign="center">
                            <Image source={googleLogo} alt="Google Logo" width="20px" style={{ marginRight: "10px" }} />
                            <Text>
                              Sign In With Google
                            </Text>
                          </HorizontalStack>
                        </Button>
                        <Link removeUnderline onClick={() => setSignInWithEmailPassword(null)}>Back</Link>
                      </VerticalStack>
                    ) : signInWithEmailPassword === 2 ? (
                      <VerticalStack gap="3">
                        <Text variant="headingLg">{email}</Text>
                        <Form onSubmit={e => {
                          e.preventDefault()
                          emailPasswordSignIn(email, password)
                        }}>
                          <VerticalStack gap="3">
                            <TextField
                              autoFocus
                              label="Password"
                              type="password"
                              value={password}
                              onChange={(value) => setPassword(value)}
                            />
                            <Button submit>
                              Sign In
                            </Button>
                          </VerticalStack>
                        </Form>
                        <VerticalStack gap="3" align="center">
                          <Link removeUnderline onClick={async () => {
                            const res = await doPasswordReset();
                            setPasswordResetSent(res);
                          }}>Forgot Password?</Link>
                          <Link removeUnderline onClick={() => setSignInWithEmailPassword(null)}>Back</Link>
                        </VerticalStack>
                      </VerticalStack>
                    ) : signInWithEmailPassword === 3 ? (
                      <VerticalStack gap="3">
                        <Text variant="headingLg">{email}</Text>
                        <Text>Login to your account for the first time</Text>
                        <Button onClick={async () => {
                          const res = await setupFirstLogin({ email })
                          if (res.data) {
                            doPasswordReset(email)
                            setSignInWithEmailPassword(5)
                          } else {
                            setToasts([{ msg: 'Error setting up account', duration: 5000, status: 'error' }])
                          }
                        }}>
                          <Text>
                            Send Login Email
                          </Text>
                        </Button>
                      </VerticalStack>
                    ) : signInWithEmailPassword === 4 ? (
                      <VerticalStack gap="3">
                        <Text variant="headingLg">No Account For This Email</Text>
                        <Text>Did a store invite you to this exact email?</Text>
                        <Button onClick={() => setSignInWithEmailPassword(0)}>
                          Back
                        </Button>
                      </VerticalStack>
                    ) : signInWithEmailPassword === 5 ? (
                      <VerticalStack gap="3">
                        <Text>Email Sent! Check your email to create a password.</Text>
                        <Text variant="headingLg">{email}</Text>
                        <Button onClick={() => setSignInWithEmailPassword(2)}>
                          <Text>
                            Sign In
                          </Text>
                        </Button>
                        <VerticalStack gap="3" align="center">
                          <Link removeUnderline onClick={async () => {
                            const res = await doPasswordReset(email);
                            setPasswordResetSent(res);
                          }}>Resend Password</Link>
                          <Link removeUnderline onClick={() => setSignInWithEmailPassword(null)}>Back</Link>
                        </VerticalStack>
                      </VerticalStack>
                    ) : (
                      <VerticalStack gap="3">
                        <Button onClick={signInWithGoogle}>
                          <HorizontalStack blockAlign="center">
                            <Image source={googleLogo} alt="Google Logo" width="20px" style={{ marginRight: "10px" }} />
                            <Text>
                              Sign In With Google
                            </Text>
                          </HorizontalStack>
                        </Button>
                        {
                          /*
                          <Button onClick={() => setCaptureEmail(true)}>
                            <Text>
                              Sign In With Email
                            </Text>
                          </Button>
*/
                        }
                        <Button onClick={() => setSignInWithEmailPassword(1)}>
                          Sign in with Email and Password
                        </Button>
                      </VerticalStack>
                    )
                  }
                </>
              )
            }
          </VerticalStack>
        </Box>
      </Modal>
    );
  }
  console.log('error', error)
  if (error) {
    return (
      <VerticalStack inlineAlign="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="800px" width="500px">
          <AlphaCard>
            <VerticalStack gap="3" inlineAlign="center">
              <VerticalStack inlineAlign="center" gap="1">
                <Text variant="headingXl">404</Text>
                <Text>No Account</Text>
              </VerticalStack>
              <Text>Ensure you've been invited by a store to get access to the dashboard</Text>
              <Button onClick={() => auth.signOut()}>Sign Out</Button>
            </VerticalStack>
          </AlphaCard>
        </Box>
      </VerticalStack>
    )
  }

  if (!profile) {
    return (
      <VerticalStack inlineAlign="center">
        <Box paddingBlockStart="16" paddingBlockEnd="32" maxWidth="800px" width="500px">
          <HorizontalStack align="center">
            <Spinner />
          </HorizontalStack>
        </Box>
      </VerticalStack>
    )
  }

  function getTaskIcon(taskString) {
    if (taskString === 'Needs Content') {
      return <Icon color="interactive" source={UploadMajor} />
    } else if (taskString === 'Waiting For Review') {
      return <Icon color="warning" source={ClockMajor} />
    } else if (taskString === 'Add Content Link') {
      return <Icon color="highlight" source={LinkMinor} />
    }
  }

  function getTask(deal) {
    if (
      deal?.status === 'active' &&
      deal?.content &&
      deal?.contentStatus === 'needsContent' || deal?.contentStatus === 'needsContentAndReview'
    ) {
      return [{
        // campaignTitle: deal?.campaignTitle,
        string: 'Content Upload Required',
        icon: getTaskIcon('Needs Content'),
      }]
    } else if (deal?.contentStatus === 'needsReview') {
      return [{
        // campaignTitle: deal?.campaignTitle,
        string: 'Waiting For Content Review',
        icon: getTaskIcon('Waiting For Review'),
      }]
    } else if (deal?.content?.baseType === 'evergreen') {
      return [{
        // campaignTitle: deal?.campaignTitle,
        string: 'Add a Content Link',
        icon: getTaskIcon('Add Content Link'),
        onClick: () => {
          window.document.getElementById('add-more-content-button')?.scrollIntoView({
            behavior: "smooth", block: "end", inline: "nearest"
          })
        }
      }]
    } else {
      return []
    }
  }

  const summaryData = {
    totalPosts: 0,
    totalEngagements: 0,
    totalClicks: 0,
    totalEarnings: 0,
    unpaidEarnings: 0,
    orders: 0,
  }
  dealData?.discountCodes?.forEach(code => {
    summaryData.totalClicks += (code.uniqueClicks || 0);
    code.orders?.forEach(order => {
      summaryData.totalEarnings += ((Number(order.subtotalPriceSet?.shopMoney?.amount) * (code.commission / 100)) || 0);
      if (!order.commissionPaid) {
        summaryData.unpaidEarnings += ((Number(order.subtotalPriceSet?.shopMoney?.amount) * (code.commission / 100)) || 0);
      }
      summaryData.orders++;
    })
  })

  const creatorPayments = []
  dealData?.payments?.forEach(payment => {
    if (payment?.paymentType === 'fixed') {
      summaryData.totalEarnings += Number(payment.value)
    }
  })

  const paymentsDue = getPaymentDueSummary(content)
  if (paymentsDue.amountDue) {
    summaryData.unpaidEarnings += paymentsDue.amountDue
  }

  content?.forEach(c => {
    if (c?.dealID === selectedDealID) {
      summaryData.totalPosts++;
      summaryData.totalEngagements += (c?.stats?.comments + c?.stats?.likes)
    }
  })

  const paymentsByShop = creatorPayments.reduce((acc, payment) => {
    if (!acc[payment.shop]) {
      acc[payment.shop] = {
        shop: payment.shop,
        totalFixedPayment: 0,
        totalCommissionPayment: 0,
        totalSalesItems: 0,
        totalOrders: 0,
        payments: []
      };
    }
    acc[payment.shop].payments.push(payment);
    acc[payment.shop].totalFixedPayment += payment.totalFixedPayment || 0;
    acc[payment.shop].totalCommissionPayment += payment.totalCommissionPayment || 0;
    acc[payment.shop].totalSalesItems += payment.totalSalesItems || 0;
    acc[payment.shop].totalOrders += payment.orders?.length || 0;
    return acc;
  }, {});

  const summaryTotals = Object.values(paymentsByShop).reduce((acc, shop) => {
    acc.totalFixedPayment += shop.totalFixedPayment;
    acc.totalCommissionPayment += shop.totalCommissionPayment;
    acc.totalPayment += shop.totalFixedPayment + shop.totalCommissionPayment;
    return acc;
  }, { totalFixedPayment: 0, totalCommissionPayment: 0, totalPayment: 0 })

  const profileDeal = profile?.deals?.[selectedDeal] || {}
  const allTasks = getTask(profileDeal)

  const profileItems = []

  console.log('localAddress', localAddress)
  if (profile?.address?.address) {
    profileItems.push({
      string: 'Shipping Address',
      subtitle: `${getCountry(profile?.address?.address?.country)}, ${profile?.address?.address?.city}`,
      icon: <Icon source={TickMinor} color="subdued" />,
      shortcutActions: [
        {
          content: 'Edit',
          onAction: () => {
            setInfoModalMarkup({
              title: 'Edit Shipping Address',
              body: (
                <VerticalStack>
                  <Modal.Section>
                    <AddressElement
                      onChange={v => {
                        console.log('setting address', v)
                        setLocalAddress(v)
                      }}
                      options={{
                        mode: 'shipping',
                        autocomplete: {
                          mode: 'google_maps_api',
                          apiKey: MAPS_KEY,
                        },
                        defaultValues: profile?.address || {}
                      }} />
                  </Modal.Section>
                </VerticalStack>
              ),
              primaryAction: {
                content: 'Save',
                loading: saveAddressLoading,
                onAction: async () => {
                  try {
                    setSaveAddressLoading(true)
                    await saveAddress(localAddress)
                    setToasts([{ msg: 'Address Updated', duration: 5000, status: 'success' }])
                    setInfoModalMarkup(null)
                    refetchProfiles()
                  } catch (e) {
                    console.error(e)
                    setToasts([{ msg: 'Error Updating Address', duration: 5000, status: 'error' }])
                  } finally {
                    setSaveAddressLoading(false)
                  }
                }
              },
              secondaryAction: {
                content: 'Cancel',
                onAction: () => setInfoModalMarkup(null)
              }
            })
          }
        }
      ],
      onClick: () => {
        setInfoModalMarkup({
          title: 'Edit Shipping Address',
          body: (
            <VerticalStack>
              <Modal.Section>
                <AddressElement
                  onChange={v => {
                    setLocalAddress(v)
                    console.log('setting address', v)
                  }}
                  options={{
                    mode: 'shipping',
                    autocomplete: {
                      mode: 'google_maps_api',
                      apiKey: MAPS_KEY,
                    },
                    defaultValues: profile?.address || {}
                  }} />
              </Modal.Section>
            </VerticalStack>
          ),
          primaryAction: {
            content: 'Save',
            loading: saveAddressLoading,
            onAction: async () => {
              try {
                setSaveAddressLoading(true)
                console.log('localAddress', localAddress)
                await saveAddress(localAddress)
                setToasts([{ msg: 'Address Updated', duration: 5000, status: 'success' }])
                setInfoModalMarkup(null)
                refetchProfiles()
              } catch (e) {
                console.error(e)
                setToasts([{ msg: 'Error Updating Address', duration: 5000, status: 'error' }])
              } finally {
                setSaveAddressLoading(false)
              }
            }
          },
          secondaryAction: {
            content: 'Cancel',
            onAction: () => setInfoModalMarkup(null)
          }
        })
      }
    })
  } else {
    profileItems.push({
      string: `Shipping Address`,
      subtitle: 'Add Now',
      icon: <Icon source={LocationMajor} color="warning" />,
      onClick: () => {
        setInfoModalMarkup({
          title: 'Edit Shipping Address',
          body: (
            <VerticalStack>
              <Modal.Section>
                <AddressElement
                  onChange={v => {
                    console.log('setting address', v)
                    setLocalAddress(v)
                  }}
                  options={{
                    mode: 'shipping',
                    autocomplete: {
                      mode: 'google_maps_api',
                      apiKey: MAPS_KEY,
                    },
                    defaultValues: profile?.address || {}
                  }} />
              </Modal.Section>
            </VerticalStack>
          ),
          primaryAction: {
            content: 'Save',
            loading: saveAddressLoading,
            onAction: async () => {
              try {
                setSaveAddressLoading(true)
                await saveAddress(localAddress)
                setToasts([{ msg: 'Address Updated', duration: 5000, status: 'success' }])
                setInfoModalMarkup(null)
                refetchProfiles()
              } catch (e) {
                console.error(e)
                setToasts([{ msg: 'Error Updating Address', duration: 5000, status: 'error' }])
              } finally {
                setSaveAddressLoading(false)
              }
            }
          },
          secondaryAction: {
            content: 'Cancel',
            onAction: () => setInfoModalMarkup(null)
          }
        })
      }
    })
  }

  if (merchantIDSaved) {
    if (!profile?.paypalMerchantID) {
      profileItems.push({
        string: 'PayPal',
        subtitle: 'Click To Connect',
        icon: <Icon source={CashDollarMajor} color="warning" />,
        onClick: async () => {
          try {
            setOnboardingLoading(true)
            const { data: link } = await getPaypalOnboardingLink({ creatorID: profile?.id, email: authUser?.email })
            window.location.href = link
          } catch (e) {
            setToasts([{ msg: 'Error connecting to PayPal', duration: 5000, status: 'critical' }])
            setOnboardingLoading(false)
          }
        },
        shortcutActions: [
          {
            content: 'Connect',
            onAction: async () => {
              try {
                setOnboardingLoading(true)
                const { data: link } = await getPaypalOnboardingLink({ creatorID: profile?.id, email: authUser?.email })
                window.location.href = link
              } catch (e) {
                setToasts([{ msg: 'Error connecting to PayPal', duration: 5000, status: 'critical' }])
                setOnboardingLoading(false)
              }
            }
          }
        ],
      })
    } else if (profile?.paypalMerchantID && !profile?.paypalEmailConfirmed) {
      profileItems.push({
        string: 'PayPal',
        subtitle: 'Confirm Your PayPal Email',
        icon: <Icon source={EnvelopeMajor} color="warning" />,
        onClick: async () => {
          setInfoModalMarkup({
            title: 'How to Confirm Your PayPal Email',
            body: (
              <Modal.Section>
                <Text>
                  Attention: Please confirm your email address on <Link removeUnderline external url="https://www.paypal.com/businessprofile/settings/">PayPal Settings</Link> in order to receive payments! You currently cannot receive payments.
                </Text>
              </Modal.Section>
            ),
            primaryAction: {
              content: 'Go to PayPal',
              onAction: () => {
                window.open('https://www.paypal.com/businessprofile/settings/', '_blank')
              }
            },
            secondaryActions: {
              content: 'Close',
              onAction: () => {
                setInfoModalMarkup(null)
              }
            }
          })
        }
      })
    } else if (profile?.paypalMerchantID && !profile?.paypalPaymentsReceivable) {
      profileItems.push({
        string: 'PayPal',
        subtitle: 'Payments Not Receivable',
        icon: <Icon source={CancelMajor} color="critical" />,
        onClick: async () => {
          setInfoModalMarkup({
            title: 'PayPal Payments Not Receivable',
            body: (
              <Modal.Section>
                <VerticalStack gap="2">
                  <Text>
                    Attention: You currently cannot receive payments due to restriction on your PayPal account.
                  </Text>
                  <Text>
                    Please reach out to PayPal Customer Support or connect to <Link removeUnderline url="https://www.paypal.com">https://www.paypal.com</Link> for more information
                  </Text>
                </VerticalStack>
              </Modal.Section>
            ),
            primaryAction: {
              content: 'Go to PayPal',
              onAction: () => {
                window.open('https://www.paypal.com', '_blank')
              }
            },
            secondaryAction: {
              content: 'Close',
              onAction: () => {
                setInfoModalMarkup(null)
              }
            }
          })
        }
      })
    } else {
      profileItems.push({
        string: "PayPal",
        subtitle: "Linked Successfully",
        shortcutActions: [
          {
            content: 'Disconnect',
            destructive: true,
            loading: removePaypalLoading,
            onAction: async () => {
              setInfoModalMarkup({
                title: 'How to Disconnect Your PayPal',
                body: (
                  <VerticalStack>
                    <Modal.Section>
                      <Text>Clicking "Disconnect" will remove your PayPal ID from our database. No more payments will be accepted. To fully disconnect:</Text>
                    </Modal.Section>
                    <Modal.Section>
                      <VerticalStack gap="2">
                        <Text variant="headingMd">To Fully Disconnect (Optional)</Text>
                        <Text>1. Go to <Link removeUnderline external url="https://www.paypal.com/myaccount/settings/">PayPal Settings</Link></Text>
                        <Text>2. Click <strong>Payments</strong> on the left sidebar</Text>
                        <Text>3. Click <strong>Manage Automatic Payments</strong></Text>
                        <Text>4. Find <strong>PartnerUp</strong> and click <strong>Cancel</strong></Text>
                      </VerticalStack>
                    </Modal.Section>
                  </VerticalStack>
                ),
                primaryAction: {
                  content: 'Disconnect',
                  destructive: true,
                  loading: removePaypalLoading,
                  onAction: async () => {
                    try {
                      setRemovePaypalLoading(true)
                      await savePaypalMerchantID(profile?.id, null, true)
                      setToasts([{ msg: 'PayPal Disconnected!', duration: 5000, status: 'success' }])
                      setInfoModalMarkup(null)
                      refetchProfiles()
                    } catch (e) {
                      alert(e)
                      console.error(e)
                      setToasts([{ msg: 'Error Disconnecting PayPal', duration: 5000, status: 'error' }])
                    } finally {
                      setRemovePaypalLoading(false)
                    }
                  }
                },
                secondaryAction: {
                  content: 'Cancel',
                  onAction: () => setInfoModalMarkup(null)
                }
              })
            }
          }
        ],
        icon: <Icon source={TickMinor} color="subdued" />,
        onClick: () => {
        }
      })
    }
  }

  const activeCode = dealData?.discountCodes?.find(c => c.isActiveCode)?.code

  const storeActionGroup = [];
  const dealActionGroup = []
  console.log('allDeals', profile?.deals)

  if (profile?.deals?.length > 1) {
    dealActionGroup.push({
      title: `Change Campaign (${profile?.deals?.length})`,
      actions: profile?.deals.map((d, i) => {
        return {
          content: <HorizontalStack gap="1">{`${i + 1} - ${d.publicTitle}`} <Badge>{d.status === 'archived' ? 'ended' : d.status}</Badge></HorizontalStack>,
          onAction: () => {
            console.log('selecting', i)
            setSelectedDeal(i)
          }
        }
      })
    })
  }

  if (profiles?.length > 1) {
    storeActionGroup.push({
      title: `Change Store (${profiles?.length})`,
      actions: profiles?.map((p, i) => {
        return {
          content: <HorizontalStack gap="1">{`${i + 1} - ${p?.storeData?.name}`}</HorizontalStack>,
          onAction: () => {
            setSelectedProfile(i)
          }
        }
      })
    })
  }

  console.log('payments', dealData?.payments)
  console.log(
    'storeActionGroup', storeActionGroup, profiles
  )

  if (profilesLoading) {
    return <Spinner />
  } else {
    return (
      <NewTopBar profile={profile} setSelectedProfile={setSelectedProfile} profiles={profiles}>
        {toastMarkup}
        <Modal
          open={infoModalMarkup}
          onClose={() => setInfoModalMarkup(null)}
          title={infoModalMarkup?.title}
          primaryAction={infoModalMarkup?.primaryAction}
          secondaryActions={infoModalMarkup?.secondaryAction ? [infoModalMarkup?.secondaryAction] : []}
        >
          {infoModalMarkup?.body}
        </Modal>
        <Page>
          <Page
            title={
              <VerticalStack gap="1">
                {
                  profile?.storeData?.logo ? (
                    <Image source={profile?.storeData?.logo} style={{ width: '20%', }} />
                  ) : (
                    <Text variant="headingSm">{profile?.storeData?.name}</Text>
                  )
                }
              </VerticalStack>
            }
            actionGroups={storeActionGroup}
          >
            <Earnings isAffiliate={profile?.deals?.some(d => d.payments?.includeAffiliate)} summaryData={summaryData} profile={profile} />
            <Page fullWidth
              actionGroups={dealActionGroup}
              title={
                <HorizontalStack gap="2">
                  <Text variant="headingLg">
                    {profileDeal?.publicTitle}
                  </Text>
                </HorizontalStack>
              }
              subtitle={
                <HorizontalStack gap="2">
                  <Text>
                    {`Invited ${new Date(profileDeal?.invitedAt)?.toLocaleString()}`}
                  </Text>
                  <Badge status={profileDeal?.status === 'active' ? 'success' : ''}>{profileDeal.status === 'archived' ? 'ended' : profileDeal.status}</Badge>
                </HorizontalStack>
              }
            >
              <VerticalStack gap="5">
                <VerticalStack gap="5">
                  <HorizontalGrid columns={{ xs: "1", md: "2fr 3fr" }} gap="3">
                    <VerticalStack gap="5">
                      <AlphaCard padding={1}>
                        <Box paddingInlineStart="5" paddingInlineEnd="3" paddingBlockStart="5" paddingBlockEnd="5">
                          <HorizontalStack align="space-between" blockAlign="center">
                            <HorizontalStack gap="2" align="start">
                              <Text variant="headingMd">To-Do</Text>
                            </HorizontalStack>
                          </HorizontalStack>
                        </Box>
                        <Divider />
                        <ResourceList
                          showHeader={false}
                          alternateTool={<Box />}
                          resourceName={{ singular: 'task', plural: 'tasks' }}
                          emptyState={
                            <VerticalStack gap="2">
                              <Box paddingInlineStart="5" paddingInlineEnd="3" paddingBlockStart="1" paddingBlockEnd="3">
                                <HorizontalStack gap="1" align="start">
                                  <HorizontalStack>
                                    <Icon source={ThumbsUpMajor} color="subdued" />
                                  </HorizontalStack>
                                  <Text>All Caught Up!</Text>
                                </HorizontalStack>
                              </Box>
                            </VerticalStack>
                          }
                          items={allTasks?.filter(task => Boolean(task)).map(task => task) || []}
                          renderItem={(task, i) => {
                            return (
                              <ResourceItem id={i} url={null} media={null} onClick={task.onClick}  >
                                <HorizontalStack gap="1" align="space-between" blockAlign="center">
                                  <HorizontalStack align="start" gap="3">
                                    <HorizontalStack>
                                      {task.icon}
                                    </HorizontalStack>
                                    <VerticalStack>
                                      <Link removeUnderline>{task?.publicTitle}</Link>
                                      <HorizontalStack gap="1">
                                        <Text>{task.string}</Text>
                                      </HorizontalStack>
                                    </VerticalStack>
                                  </HorizontalStack>
                                  {
                                    task.dueDate ? (
                                      <Badge>Due {new Date(task.dueDate)?.toLocaleDateString()}</Badge>
                                    ) : null
                                  }
                                </HorizontalStack>
                              </ResourceItem>
                            )
                          }} />
                      </AlphaCard>
                      {
                        activeCode ? (
                          <AlphaCard padding={1}>
                            <VerticalStack gap="2">
                              <Box paddingInlineStart="5" paddingInlineEnd="3" paddingBlockStart="5" paddingBlockEnd="5">
                                <HorizontalStack align="space-between" blockAlign="center">
                                  <HorizontalStack gap="2" align="start">
                                    <Text variant="headingMd">Affiliate</Text>
                                  </HorizontalStack>
                                  {
                                    /*
    <VerticalStack inlineAlign="end">
    <Text>Buyers get {profile?.[0]?.deals?.[0]?.affiliateFields?.discountPercentage}% off</Text>
    <Text>You earn {profile?.[0]?.deals?.[0]?.affiliateFields?.commission}% on all sales</Text>
    </VerticalStack>
    */
                                  }
                                </HorizontalStack>
                              </Box>
                              <Divider />
                              {/*
<HorizontalStack blockAlign="center" align="space-between">
<VerticalStack>
<Text color="subdued">Your code</Text>
<Text variant="headingMd" color="success">
{
profile?.[0]?.discountCodes?.[0]?.code
}
</Text>
</VerticalStack>
</HorizontalStack>
<Divider />
*/}
                              <Box padding="3" paddingBlockStart="0">
                                <VerticalStack gap="3">
                                  <VerticalStack gap="2">
                                    <VerticalStack inlineAlign="start">
                                      <Text variant="bodyMd" color="subdued">Your Code</Text>
                                      <Text variant="headingMd" color="success">
                                        {
                                          activeCode
                                        }
                                      </Text>
                                    </VerticalStack>
                                    <VerticalStack inlineAlign="start">
                                      <Text variant="bodyMd" color="subdued">Your Link</Text>
                                      <Link removeUnderline>
                                        {
                                          'https://' + profile?.storeData?.customDomain + '.prup.io/' + activeCode
                                        }
                                      </Link>
                                    </VerticalStack>
                                    <ButtonGroup>
                                      <Button icon={DuplicateMinor} onClick={() => copyToClipboard('https://' + profile?.storeData?.customDomain + '.prup.io/' + activeCode, setToasts)}>Copy Link</Button>
                                    </ButtonGroup>
                                  </VerticalStack>
                                </VerticalStack>
                              </Box>
                            </VerticalStack>
                          </AlphaCard>
                        ) : null
                      }
                      <AlphaCard padding="0">
                        <Box paddingInlineStart="5" paddingInlineEnd="3" paddingBlockStart="5" paddingBlockEnd="5">
                          <HorizontalStack align="space-between" blockAlign="center">
                            <HorizontalStack gap="2" align="start">
                              <Text variant="headingMd">Profile</Text>
                              {onboardingLoading ? <Spinner size="small" /> : null}
                            </HorizontalStack>
                          </HorizontalStack>
                        </Box>
                        <Divider />
                        <ResourceList
                          alternateTool={<Box />}
                          resourceName={{ singular: 'profile item', plural: 'profile items' }}
                          items={profileItems || []}
                          showHeader={false}
                          renderItem={(item, i) => {
                            return (
                              <ResourceItem id={i} url={null} media={null} onClick={item.onClick} shortcutActions={item.shortcutActions || null}  >
                                <HorizontalStack gap="1" align="space-between" blockAlign="center">
                                  <HorizontalStack align="start" gap="3">
                                    <HorizontalStack>
                                      {item.icon}
                                    </HorizontalStack>
                                    <VerticalStack>
                                      <Text variant="bodySm" color="subdued">
                                        {item.string}
                                      </Text>
                                      <div>{item.subtitle}</div>
                                    </VerticalStack>
                                  </HorizontalStack>
                                </HorizontalStack>
                              </ResourceItem>
                            )
                          }} />
                      </AlphaCard>
                      <AlphaCard padding="0">
                        <VerticalStack gap="2">
                          <Box paddingInlineStart="5" paddingInlineEnd="3" paddingBlockStart="5" paddingBlockEnd="3">
                            <HorizontalStack align="space-between" blockAlign="center">
                              <HorizontalStack gap="2" align="start">
                                <Text variant="headingMd">Performance</Text>
                              </HorizontalStack>
                            </HorizontalStack>
                          </Box>
                          <Divider />
                          <Box>
                            <Tabs fitted tabs={profileDeal?.payments?.includeAffiliate ? [
                              { id: 'orders', content: 'Sales' },
                              { id: 'payments', content: 'Payments' },
                            ] : [{ id: 'payments', content: 'Payments' }]}
                              selected={profileDeal?.payments?.includeAffiliate ? selectedPaymentTab : 1}
                              onSelect={v => setSelectedPaymentTab(v)} />
                            <VerticalStack gap="3">
                              {
                                profileDeal?.payments?.includeAffiliate && selectedPaymentTab === 0 ? (
                                  <AffiliateTable
                                    discountCodes={dealData?.discountCodes}
                                    profile={profile}
                                  />
                                ) : (
                                  <PaymentsTable payments={dealData?.payments} />
                                )
                              }
                            </VerticalStack>
                          </Box>
                        </VerticalStack>
                      </AlphaCard>
                    </VerticalStack>
                    <DealModal
                      content={content}
                      refetchContent={refetchContent}
                      profile={profile}
                      refetchDeal={refetchDeal}
                      storeCustomDomain={profile?.storeData?.customDomain}
                      deal={profileDeal}
                      onClose={() => setSelectedDeal(null)}
                      payments={dealData?.payments}
                    />
                  </HorizontalGrid>
                </VerticalStack>
              </VerticalStack>
            </Page>
          </Page>
        </Page>
      </NewTopBar>
    )
  }

  function getPaymentDueSummary(content) {
    const deal = profile?.deals[selectedDeal]
    const paymentDueSummary = {
      amountDue: 0,
      contentCount: 0,
      contentIDs: []
    };
    if (content?.length) {
      content.forEach(c => {
        if (deal?.payments?.price && !c?.paid) {
          const count = (deal?.content?.formats || []).reduce((acc, obj) => {
            const key = Object.keys(obj)[0]
            if (key) acc += obj[key]
            return acc
          }, 0) || 0
          if (deal?.payments?.whenPayment === 'Up Front') {
            paymentDueSummary.amountDue += Number(deal?.payments?.price) / Number(count || 1)
            paymentDueSummary.contentCount += 1
            paymentDueSummary.contentIDs.push(c.id)
          } else if (c?.status === 'approved' || c.status === 'deployed') {
            paymentDueSummary.amountDue += Number(deal?.payments?.price) / Number(count || 1)
            paymentDueSummary.contentCount += 1
            paymentDueSummary.contentIDs.push(c.id)
          }
        }
      })
    }
    return paymentDueSummary
  }

  async function getSingleVimeoEmbed(contentID, vimeoID) {
    let res;
    try {
      res = await getEmbedByVimeoID(vimeoID)
    } catch (e) {
      console.error('error getting embed', e)
      return {
        embed: <><Text variant="headingLg">404</Text><Text variant="headingSm">Upload Not Found</Text></>,
        contentID
      }
    }
    if (!res.uploadComplete) {
      return {
        embed: <><Text variant="headingMd">Upload Failed</Text><Text>Please Retry</Text></>,
        contentID
      }
    } else if (!res.transcodeComplete) {
      //  recursive retry
      //  prevent multiple timeouts
      // 
      return {
        retry: true,
        embed: <HorizontalStack gap="2"><Spinner /><VerticalStack gap="2"><Text variant="headingMd">Video Processing...</Text><Text>You can leave this page. It will be ready soon</Text></VerticalStack></HorizontalStack>,
        contentID
      }
    }
    return {
      embed: <div dangerouslySetInnerHTML={{ __html: res.html }} />,
      contentID
    }
  }


  async function getAllVimeoEmbeds(content) {
    const promises = [];
    content.forEach((c) => {
      if (c.mostRecentUpload) {
        promises.push(getSingleVimeoEmbed(c.id, c.mostRecentUpload));
      } else if (c.directLink) {
        promises.push(
          Promise.resolve({
            embed: <Link url={c.directLink} target="_blank">{c.directLink}</Link>,
            contentID: c.id
          })
        )
      }
    })
    const embeds = await Promise.all(promises);
    if (embeds.some(e => e.retry)) {
      if (!retryTimeout) {
        const timeout = setTimeout(() => {
          getAllVimeoEmbeds(content)
          setRetryTimeout(null)
        }, 15000)
        setRetryTimeout(timeout)
      }
    }
    const embedsMap = {}
    embeds.forEach(embed => {
      embedsMap[embed.contentID] = embed.embed
    })
    setVimeoEmbedsMap(embedsMap)
  }
}
